import React from 'react';

const Spinner: React.FC = () => {
  return (
    <div className="Spinner">
      <div className="Spinner-action" />
    </div>
  );
};

export default Spinner;
